/* v8 ignore start */
/**
 * @public
 */
export const enum LottieTextJustify {
  Left = 0,
  Right = 1,
  Center = 2,
  JustifyWithLastLineLeft = 3,
  JustifyWithLastLineRight = 4,
  JustifyWithLastLineCenter = 5,
  JustifyWithLastLineFull = 6,
}
/* v8 ignore stop */
